export default class LanguageService {

}
